export default __webpack_public_path__ + "static/media/exterior1.2c5a1ce5.jpeg";